import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CashDifferenceService {

    constructor(private http: HttpClient) { }

    adjustCashDifferences(tellerId: string, data: any): Observable<any> {
        return this.http.post(`/tellers/${tellerId}/cash-difference`, data);
    }
}
